async function addMarkerImagesToMap(maplibreMap) {
  const imgFiles = import.meta.glob('/src/img/markers/*.png');

  await Promise.all(
    Object.keys(imgFiles).map(async (filePath) => {
      const fileName = filePath.split('/').pop();
      const imgSrc = `/img/markers/${fileName}`;
      const image = await maplibreMap.loadImage(imgSrc);
      maplibreMap.addImage(
        fileName.replace(/\.[^/.]+$/, ''), 
        image.data,
        { sdf: fileName.startsWith('sdf-') },
      );
    }),
  );
}

export { addMarkerImagesToMap };